<template>
  <TWModal
    :title="$t('envelope.cancelEnvelopeModalTitle')"
    :show="show"
    :loading="loading"
    @close="$emit('close')"
  >
    <template v-slot:content>
      <p>{{ $t('envelope.cancelEnvelopeWarning1') }}</p>
      <p>{{ $t('envelope.cancelEnvelopeWarning2') }}</p>
    </template>

    <template v-slot:controls>
      <BaseButton
        variant="invisible"
        @click.native="$emit('close')"
        data-ec="envelope_cancel_modal"
        data-et="go_back_button"
      >
        {{ $t('functional.actuallyNoThanks') }}
      </BaseButton>

      <BaseButton
        @click.native="cancelEnvelope"
        variant="danger"
        data-ec="envelope_cancel_modal"
        data-et="cancel_envelope_button"
      >
        {{ $t('envelope.cancelEnvelope') }}
      </BaseButton>
    </template>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';

export default {
  name: 'EnvelopeCancelModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    envelope: {
      type: [Object],
      required: true,
    },
  },
  components: {
    TWModal,
    BaseButton,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async cancelEnvelope() {
      this.loading = true;
      try {
        await this.$store.dispatch('envelopes/CANCEL_ENVELOPE', this.envelope.fingerprint);
        this.$emit('envelopeCancelled');
        this.$emit('close');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

